export class Logging {
  public static info(message?: any, ...optionalParams: any[]): void {
    // eslint-disable-next-line no-console
    console.info(message, ...optionalParams);
  }
  public static warn(message?: any, ...optionalParams: any[]): void {
    // eslint-disable-next-line no-console
    console.warn(message, ...optionalParams);
  }
  public static error(message?: any, ...optionalParams: any[]) {
    // eslint-disable-next-line no-console
    console.error(message, ...optionalParams);
  }
}
